<template>
  <div class="exam-root" v-loading="loading">
    <!-- 椤堕儴淇℃伅鏍?-->
    <div class="exam-header" v-if="examinationInfo != null">
      <div class="header-left">
        <div class="header-cell exam-name-cell">
          <span class="header-label exam-name-text">{{
            $route.query.examinationName
          }}</span>
        </div>
        <div class="header-cell">
          <i class="el-icon-folder"></i>
          <span class="header-label">科目</span>
          <el-input
            :value="examinationInfo.examinationCoursesName"
            placeholder=""
            readonly
            size="small"
            class="header-input small-width"
          ></el-input>
        </div>
        <div class="header-cell">
          <i class="el-icon-time"></i>
          <span class="header-label">考试时长</span>
          <el-input
            :value="examinationInfo.examinationMinute"
            placeholder=""
            readonly
            size="small"
            class="header-input tiny-width"
          ></el-input>
        </div>
        <div class="header-cell">
          <i class="el-icon-time"></i>
          <span class="header-label">剩余时长</span>
          <el-input
            :value="countdown"
            placeholder=""
            readonly
            size="small"
            class="header-input tiny-width"
          ></el-input>
        </div>
      </div>
      <div class="header-right">
        <el-button
          size="small"
          icon="el-icon-refresh"
          @click="changeLayout"
          class="layout-btn"
          >更改布局</el-button
        >
        <el-button
          type="primary"
          size="small"
          :disabled="isSubmitDisabled"
          @click="submitFunc"
          :loading="submitLoading"
          class="submit-btn"
          >交卷</el-button
        >
      </div>
    </div>

    <!-- 涓讳綋锛氬乏渚у鑸?+ 鍙充晶棰樼洰 -->
    <div class="exam-body page">
      <!-- 宸︿晶瀵艰埅闈㈡澘 -->
      <div class="left-panel">
        <!-- 瀛︾敓淇℃伅 -->
        <div class="user-profile">
          <img
            class="avatar"
            :src="avataricon || require('../../../assets/img/icontouxiang.png')"
          />
          <div class="user-info">
            <div class="uname">姓名: {{ userInfo.studentName || "" }}</div>
            <div class="uno">学号: {{ userInfo.studentNo || "" }}</div>
          </div>
        </div>

        <!-- 棰樺彿鎶樺彔瀵艰埅 -->
        <el-collapse class="nav-collapse" accordion value="SingX">
          <el-collapse-item name="SingX" v-if="SingXList.length > 0">
            <template slot="title">单选题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in SingXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'singx' && subjectIndex === index,
                  answered: singIndex[index] !== ''
                }"
                @click="
                  switchItem('singx');
                  singxIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="MultX" v-if="MultXList.length > 0">
            <template slot="title">多选题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in MultXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'multx' && subjectIndex === index,
                  answered: item.answers && item.answers.length > 0
                }"
                @click="
                  switchItem('multx');
                  multiIndexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="JudgX" v-if="JudgXList.length > 0">
            <template slot="title">判断题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in JudgXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'judgex' && subjectIndex === index,
                  answered: judgIndex[index] !== ''
                }"
                @click="
                  switchItem('judgex');
                  judgexChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="FillX" v-if="FillXList.length > 0">
            <template slot="title">填空题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in FillXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'fillx' && subjectIndex === index,
                  answered:
                    attachments[item.id] && attachments[item.id].length > 0
                }"
                @click="
                  switchItem('fillx');
                  fillxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="ProofX" v-if="ProofXList.length > 0">
            <template slot="title">证明题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in ProofXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'proofx' && subjectIndex === index,
                  answered:
                    attachments[item.id] && attachments[item.id].length > 0
                }"
                @click="
                  switchItem('proofx');
                  proofxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
          <el-collapse-item name="AnwsX" v-if="AnwsXList.length > 0">
            <template slot="title">计算题</template>
            <div class="nav-grid">
              <span
                v-for="(item, index) in AnwsXList"
                :key="index"
                class="nav-circle"
                :class="{
                  active: subjectType === 'anwsx' && subjectIndex === index,
                  answered:
                    attachments[item.id] && attachments[item.id].length > 0
                }"
                @click="
                  switchItem('anwsx');
                  anwsxChange(index);
                "
                >{{ index + 1 }}</span
              >
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>

      <!-- 鍙充晶棰樼洰鍖哄煙 -->
      <div class="right" :class="{ 'scroll-layout-right': !layout }">
        <div
          class="item"
          :key="subjectType + '-' + subjectIndex"
          v-if="layout === true"
        >
          <!-- 鍗曢€夐 -->
          <div
            class="title"
            v-if="
              subjectType === 'singx' &&
                SingXList.length > 0 &&
                SingXList1.length > 0
            "
          >
            <div
              v-for="(item, index) in SingXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="index === 0 && j === 0"
                  >{{ subjectIndex + 1 }}.</span
                >
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
                <span
                  v-if="
                    index === SingXList1[subjectIndex].steam.length - 1 &&
                      j === item.wordInfos.length - 1
                  "
                  >（{{ SingXList1[subjectIndex].score }}分）</span
                >
              </span>
            </div>
          </div>
          <div
            class="groupbox"
            v-if="
              subjectType === 'singx' &&
                SingXList.length > 0 &&
                SingXList1.length > 0
            "
          >
            <el-radio-group
              v-model="singIndex[subjectIndex]"
              class="el_radio_group"
              @change="SingXListFnc(singIndex[subjectIndex])"
            >
              <div
                v-for="(item, index) in SingXList1[subjectIndex].options"
                :key="index"
                class="option-row"
              >
                <el-radio :label="orderList[index].label" class="el_radio">
                  <div class="option-wrapper">
                    <span
                      class="custom-checkbox"
                      :class="{
                        'is-checked':
                          singIndex[subjectIndex] === orderList[index].label
                      }"
                    ></span>
                    <span class="practice-label">{{
                      orderList[index].label
                    }}</span>
                    <span class="option-content">
                      <span v-for="(t, i) in item.ranginfos" :key="i">
                        <span v-for="(it, j) in t.wordInfos" :key="j">
                          <span v-if="it.wdType === 1" v-katex
                            >${{ it.latex }}$</span
                          >
                          <img v-else-if="it.wdType === 2" :src="it.buffer" />
                          <span v-else>{{ it.content }}</span>
                        </span>
                      </span>
                    </span>
                  </div>
                </el-radio>
                <br />
              </div>
            </el-radio-group>
          </div>

          <!-- 澶氶€夐 -->
          <div
            class="title"
            v-if="
              subjectType === 'multx' &&
                MultXList.length > 0 &&
                MultXList1.length > 0
            "
          >
            <div
              v-for="(item, index) in MultXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="index === 0 && j === 0"
                  >{{ subjectIndex + 1 }}.</span
                >
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
                <span
                  v-if="
                    index === MultXList1[subjectIndex].steam.length - 1 &&
                      j === item.wordInfos.length - 1
                  "
                  >（{{ MultXList1[subjectIndex].score }}分）</span
                >
              </span>
            </div>
          </div>
          <div
            class="groupcheckbox"
            v-if="subjectType === 'multx' && MultXList1.length > 0"
          >
            <el-checkbox-group
              v-model="multipleTemp"
              class="el_radio_group"
              @change="MultXListChange($event, subjectIndex)"
            >
              <div
                v-for="(item, index) in MultXList1[subjectIndex].options"
                :key="index"
                class="option-row"
              >
                <el-checkbox
                  :label="orderList[index].label"
                  class="el_radio"
                  :key="index"
                >
                  <div class="option-wrapper">
                    <span
                      class="custom-checkbox"
                      :class="{
                        'is-checked': (multipleTemp || []).includes(
                          orderList[index].label
                        )
                      }"
                    ></span>
                    <span class="practice-label">{{
                      orderList[index].label
                    }}</span>
                    <span class="option-content">
                      <span v-for="(t, i) in item.ranginfos" :key="i">
                        <span v-for="(it, j) in t.wordInfos" :key="j">
                          <span v-if="it.wdType === 1" v-katex
                            >${{ it.latex }}$</span
                          >
                          <img v-else-if="it.wdType === 2" :src="it.buffer" />
                          <span v-else>{{ it.content }}</span>
                        </span>
                      </span>
                    </span>
                  </div>
                </el-checkbox>
              </div>
            </el-checkbox-group>
          </div>

          <!-- 鍒ゆ柇棰?-->
          <div
            class="title"
            v-if="
              subjectType === 'judgex' &&
                JudgXList.length > 0 &&
                JudgXList1.length > 0
            "
          >
            <div
              v-for="(item, index) in JudgXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="index === 0 && j === 0"
                  >{{ subjectIndex + 1 }}.</span
                >
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
                <span
                  v-if="
                    index === JudgXList1[subjectIndex].steam.length - 1 &&
                      j === item.wordInfos.length - 1
                  "
                  >（{{ JudgXList1[subjectIndex].score }}分）</span
                >
              </span>
            </div>
          </div>
          <div v-if="subjectType === 'judgex' && JudgXList.length > 0">
            <el-radio-group
              v-model="judgIndex[subjectIndex]"
              class="el_radio_group"
              @change="JudgXListFnc(judgIndex[subjectIndex])"
            >
              <el-radio :label="1" class="el_radio">
                <span class="box"><i class="el-icon-circle-check"></i></span>
              </el-radio>
              <br />
              <el-radio :label="0" class="el_radio">
                <span class="box"><i class="el-icon-circle-close"></i></span>
              </el-radio>
            </el-radio-group>
          </div>

          <!-- 填空题 (只读) -->
          <div
            class="title"
            v-if="subjectType === 'fillx' && FillXList1.length > 0"
          >
            <div
              v-for="(item, index) in FillXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="index === 0 && j === 0"
                  >{{ subjectIndex + 1 }}.</span
                >
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
                <span
                  v-if="
                    index === FillXList1[subjectIndex].steam.length - 1 &&
                      j === item.wordInfos.length - 1
                  "
                  >（{{ FillXList1[subjectIndex].score }}分）</span
                >
              </span>
            </div>
            <!-- 附件上传 (单题模式 - 填空题) -->
            <div class="attachment-container">
              <div class="attachment-header">
                <i class="el-icon-picture"></i>
                <span>答题附件 (填空题)</span>
              </div>
              <div class="attachment-list">
                <div
                  v-for="file in attachments[FillXList1[subjectIndex].id] || []"
                  :key="file.id"
                  class="attachment-item"
                >
                  <el-image
                    :src="file.url"
                    :preview-src-list="[file.url]"
                    fit="cover"
                  ></el-image>
                  <i
                    class="el-icon-delete delete-btn"
                    @click="
                      handleAttachmentDelete(file.id, FillXList1[subjectIndex])
                    "
                  ></i>
                </div>
                <el-upload
                  action=""
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="
                    file =>
                      handleAttachmentUpload(
                        file,
                        $route.query.paperId,
                        FillXList1[subjectIndex]
                      )
                  "
                  accept="image/*"
                >
                  <div class="upload-trigger">
                    <i class="el-icon-plus"></i>
                    <span>添加图片</span>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>

          <!-- 证明题 (只读) -->
          <div
            class="title"
            v-if="subjectType === 'proofx' && ProofXList1.length > 0"
          >
            <div
              v-for="(item, index) in ProofXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="index === 0 && j === 0"
                  >{{ subjectIndex + 1 }}.</span
                >
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
                <span
                  v-if="
                    index === ProofXList1[subjectIndex].steam.length - 1 &&
                      j === item.wordInfos.length - 1
                  "
                  >（{{ ProofXList1[subjectIndex].score }}分）</span
                >
              </span>
            </div>
            <!-- 附件上传 (单题模式 - 证明题) -->
            <div class="attachment-container">
              <div class="attachment-header">
                <i class="el-icon-picture"></i>
                <span>答题附件 (证明题)</span>
              </div>
              <div class="attachment-list">
                <div
                  v-for="file in attachments[ProofXList1[subjectIndex].id] ||
                    []"
                  :key="file.id"
                  class="attachment-item"
                >
                  <el-image
                    :src="file.url"
                    :preview-src-list="[file.url]"
                    fit="cover"
                  ></el-image>
                  <i
                    class="el-icon-delete delete-btn"
                    @click="
                      handleAttachmentDelete(file.id, ProofXList1[subjectIndex])
                    "
                  ></i>
                </div>
                <el-upload
                  action=""
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="
                    file =>
                      handleAttachmentUpload(
                        file,
                        $route.query.paperId,
                        ProofXList1[subjectIndex]
                      )
                  "
                  accept="image/*"
                >
                  <div class="upload-trigger">
                    <i class="el-icon-plus"></i>
                    <span>添加图片</span>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>

          <!-- 计算题 (只读) -->
          <div
            class="title"
            v-if="subjectType === 'anwsx' && AnwsXList1.length > 0"
          >
            <div
              v-for="(item, index) in AnwsXList1[subjectIndex].steam"
              :key="index"
            >
              <span v-for="(i, j) in item.wordInfos" :key="j">
                <span v-if="index === 0 && j === 0"
                  >{{ subjectIndex + 1 }}.</span
                >
                <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                <img v-else-if="i.wdType === 2" :src="i.buffer" />
                <span v-else>{{ i.content }}</span>
                <span
                  v-if="
                    index === AnwsXList1[subjectIndex].steam.length - 1 &&
                      j === item.wordInfos.length - 1
                  "
                  >（{{ AnwsXList1[subjectIndex].score }}分）</span
                >
              </span>
            </div>
            <!-- 附件上传 (单题模式 - 计算题) -->
            <div class="attachment-container">
              <div class="attachment-header">
                <i class="el-icon-picture"></i>
                <span>答题附件 (计算题)</span>
              </div>
              <div class="attachment-list">
                <div
                  v-for="file in attachments[AnwsXList1[subjectIndex].id] || []"
                  :key="file.id"
                  class="attachment-item"
                >
                  <el-image
                    :src="file.url"
                    :preview-src-list="[file.url]"
                    fit="cover"
                  ></el-image>
                  <i
                    class="el-icon-delete delete-btn"
                    @click="
                      handleAttachmentDelete(file.id, AnwsXList1[subjectIndex])
                    "
                  ></i>
                </div>
                <el-upload
                  action=""
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="
                    file =>
                      handleAttachmentUpload(
                        file,
                        $route.query.paperId,
                        AnwsXList1[subjectIndex]
                      )
                  "
                  accept="image/*"
                >
                  <div class="upload-trigger">
                    <i class="el-icon-plus"></i>
                    <span>添加图片</span>
                  </div>
                </el-upload>
              </div>
            </div>
          </div>

          <!-- 搴曢儴涓婁竴棰?涓嬩竴棰?-->
          <div class="bottom-nav">
            <el-button class="last" @click="last" type="primary"
              >上一题</el-button
            >
            <div class="line">|</div>
            <el-button class="next" @click="next" type="primary"
              >下一题</el-button
            >
          </div>
        </div>
        <div class="scroll-content" v-else>
          <!-- ========== 鍗曢€夐 ========== -->
          <div class="question-section" v-if="SingXList.length > 0">
            <div class="section-header">
              一、单选题（共 {{ SingXList.length }} 题）
            </div>
            <div
              class="question-item"
              v-for="(qItem, qIdx) in SingXList1"
              :key="'scroll-sing-' + qIdx"
            >
              <div class="title">
                <div v-for="(item, index) in qItem.steam" :key="index">
                  <span v-for="(i, j) in item.wordInfos" :key="j">
                    <span v-if="index === 0 && j === 0">{{ qIdx + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        index === qItem.steam.length - 1 &&
                          j === item.wordInfos.length - 1
                      "
                      >（{{ qItem.score }}分）</span
                    >
                  </span>
                </div>
              </div>
              <div class="groupbox">
                <el-radio-group
                  v-model="singIndex[qIdx]"
                  class="el_radio_group"
                  @change="scrollSingChange(singIndex[qIdx], qIdx)"
                >
                  <div
                    v-for="(optItem, optIdx) in qItem.options"
                    :key="optIdx"
                    class="option-row"
                  >
                    <el-radio :label="orderList[optIdx].label" class="el_radio">
                      <div class="option-wrapper">
                        <span
                          class="custom-checkbox"
                          :class="{
                            'is-checked':
                              singIndex[qIdx] === orderList[optIdx].label
                          }"
                        ></span>
                        <span class="practice-label">{{
                          orderList[optIdx].label
                        }}</span>
                        <span class="option-content">
                          <span v-for="(t, i) in optItem.ranginfos" :key="i">
                            <span v-for="(it, j) in t.wordInfos" :key="j">
                              <span v-if="it.wdType === 1" v-katex
                                >${{ it.latex }}$</span
                              >
                              <img
                                v-else-if="it.wdType === 2"
                                :src="it.buffer"
                              />
                              <span v-else>{{ it.content }}</span>
                            </span>
                          </span>
                        </span>
                      </div>
                    </el-radio>
                  </div>
                </el-radio-group>
              </div>
            </div>
          </div>

          <!-- ========== 澶氶€夐 ========== -->
          <div class="question-section" v-if="MultXList.length > 0">
            <div class="section-header">
              二、多选题（共 {{ MultXList.length }} 题）
            </div>
            <div
              class="question-item"
              v-for="(qItem, qIdx) in MultXList1"
              :key="'scroll-mult-' + qIdx"
            >
              <div class="title">
                <div v-for="(item, index) in qItem.steam" :key="index">
                  <span v-for="(i, j) in item.wordInfos" :key="j">
                    <span v-if="index === 0 && j === 0">{{ qIdx + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        index === qItem.steam.length - 1 &&
                          j === item.wordInfos.length - 1
                      "
                      >（{{ qItem.score }}分）</span
                    >
                  </span>
                </div>
              </div>
              <div class="groupcheckbox">
                <el-checkbox-group
                  v-model="MultXList[qIdx].answers"
                  class="el_radio_group"
                  @change="MultXListChange($event, qIdx)"
                >
                  <div
                    v-for="(optItem, optIdx) in qItem.options"
                    :key="optIdx"
                    class="option-row"
                  >
                    <el-checkbox
                      :label="orderList[optIdx].label"
                      class="el_radio"
                    >
                      <div class="option-wrapper">
                        <span
                          class="custom-checkbox"
                          :class="{
                            'is-checked': (
                              MultXList[qIdx].answers || []
                            ).includes(orderList[optIdx].label)
                          }"
                        ></span>
                        <span class="practice-label">{{
                          orderList[optIdx].label
                        }}</span>
                        <span class="option-content">
                          <span v-for="(t, i) in optItem.ranginfos" :key="i">
                            <span v-for="(it, j) in t.wordInfos" :key="j">
                              <span v-if="it.wdType === 1" v-katex
                                >${{ it.latex }}$</span
                              >
                              <img
                                v-else-if="it.wdType === 2"
                                :src="it.buffer"
                              />
                              <span v-else>{{ it.content }}</span>
                            </span>
                          </span>
                        </span>
                      </div>
                    </el-checkbox>
                  </div>
                </el-checkbox-group>
              </div>
            </div>
          </div>

          <!-- ========== 判断题 ========== -->
          <div class="question-section" v-if="JudgXList.length > 0">
            <div class="section-header">
              三、判断题（共 {{ JudgXList.length }} 题）
            </div>
            <div
              class="question-item"
              v-for="(qItem, qIdx) in JudgXList1"
              :key="'scroll-judg-' + qIdx"
            >
              <div class="title">
                <div v-for="(item, index) in qItem.steam" :key="index">
                  <span v-for="(i, j) in item.wordInfos" :key="j">
                    <span v-if="index === 0 && j === 0">{{ qIdx + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        index === qItem.steam.length - 1 &&
                          j === item.wordInfos.length - 1
                      "
                      >（{{ qItem.score }}分）</span
                    >
                  </span>
                </div>
              </div>
              <div>
                <el-radio-group
                  v-model="judgIndex[qIdx]"
                  class="el_radio_group"
                  @change="scrollJudgChange(judgIndex[qIdx], qIdx)"
                >
                  <el-radio :label="1" class="el_radio">
                    <span class="box"
                      ><i class="el-icon-circle-check"></i
                    ></span>
                  </el-radio>
                  <br />
                  <el-radio :label="0" class="el_radio">
                    <span class="box"
                      ><i class="el-icon-circle-close"></i
                    ></span>
                  </el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>

          <!-- ========== 填空题 ========== -->
          <div class="question-section" v-if="FillXList.length > 0">
            <div class="section-header">
              四、填空题（共 {{ FillXList.length }} 题）
            </div>
            <div
              class="question-item"
              v-for="(qItem, qIdx) in FillXList1"
              :key="'scroll-fill-' + qIdx"
            >
              <div class="title">
                <div v-for="(item, index) in qItem.steam" :key="index">
                  <span v-for="(i, j) in item.wordInfos" :key="j">
                    <span v-if="index === 0 && j === 0">{{ qIdx + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        index === qItem.steam.length - 1 &&
                          j === item.wordInfos.length - 1
                      "
                      >（{{ qItem.score }}分）</span
                    >
                  </span>
                </div>
              </div>
              <!-- 附件上传 (滚动模式 - 填空题) -->
              <div class="attachment-container">
                <div class="attachment-header">
                  <i class="el-icon-picture"></i>
                  <span>答题附件</span>
                </div>
                <div class="attachment-list">
                  <div
                    v-for="file in attachments[qItem.id] || []"
                    :key="file.id"
                    class="attachment-item"
                  >
                    <el-image
                      :src="file.url"
                      :preview-src-list="[file.url]"
                      fit="cover"
                    ></el-image>
                    <i
                      class="el-icon-delete delete-btn"
                      @click="handleAttachmentDelete(file.id, qItem)"
                    ></i>
                  </div>
                  <el-upload
                    action=""
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="
                      file =>
                        handleAttachmentUpload(
                          file,
                          $route.query.paperId,
                          qItem
                        )
                    "
                    accept="image/*"
                  >
                    <div class="upload-trigger">
                      <i class="el-icon-plus"></i>
                      <span>添加图片</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>

          <!-- ========== 证明题 ========== -->
          <div class="question-section" v-if="ProofXList.length > 0">
            <div class="section-header">
              五、证明题（共 {{ ProofXList.length }} 题）
            </div>
            <div
              class="question-item"
              v-for="(qItem, qIdx) in ProofXList1"
              :key="'scroll-proof-' + qIdx"
            >
              <div class="title">
                <div v-for="(item, index) in qItem.steam" :key="index">
                  <span v-for="(i, j) in item.wordInfos" :key="j">
                    <span v-if="index === 0 && j === 0">{{ qIdx + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        index === qItem.steam.length - 1 &&
                          j === item.wordInfos.length - 1
                      "
                      >（{{ qItem.score }}分）</span
                    >
                  </span>
                </div>
              </div>
              <!-- 附件上传 (滚动模式 - 证明题) -->
              <div class="attachment-container">
                <div class="attachment-header">
                  <i class="el-icon-picture"></i>
                  <span>答题附件</span>
                </div>
                <div class="attachment-list">
                  <div
                    v-for="file in attachments[qItem.id] || []"
                    :key="file.id"
                    class="attachment-item"
                  >
                    <el-image
                      :src="file.url"
                      :preview-src-list="[file.url]"
                      fit="cover"
                    ></el-image>
                    <i
                      class="el-icon-delete delete-btn"
                      @click="handleAttachmentDelete(file.id, qItem)"
                    ></i>
                  </div>
                  <el-upload
                    action=""
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="
                      file =>
                        handleAttachmentUpload(
                          file,
                          $route.query.paperId,
                          qItem
                        )
                    "
                    accept="image/*"
                  >
                    <div class="upload-trigger">
                      <i class="el-icon-plus"></i>
                      <span>添加图片</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>

          <!-- ========== 计算题 (滚动模式) ========== -->
          <div class="question-section" v-if="AnwsXList.length > 0">
            <div class="section-header">
              六、计算题（共 {{ AnwsXList.length }} 题）
            </div>
            <div
              class="question-item"
              v-for="(qItem, qIdx) in AnwsXList1"
              :key="'scroll-anws-' + qIdx"
            >
              <div class="title">
                <div v-for="(item, index) in qItem.steam" :key="index">
                  <span v-for="(i, j) in item.wordInfos" :key="j">
                    <span v-if="index === 0 && j === 0">{{ qIdx + 1 }}.</span>
                    <span v-if="i.wdType === 1" v-katex>${{ i.latex }}$</span>
                    <img v-else-if="i.wdType === 2" :src="i.buffer" />
                    <span v-else>{{ i.content }}</span>
                    <span
                      v-if="
                        index === qItem.steam.length - 1 &&
                          j === item.wordInfos.length - 1
                      "
                      >（{{ qItem.score }}分）</span
                    >
                  </span>
                </div>
              </div>
              <!-- 附件上传 -->
              <div class="attachment-container">
                <div class="attachment-header">
                  <i class="el-icon-picture"></i>
                  <span>答题附件</span>
                </div>
                <div class="attachment-list">
                  <div
                    v-for="file in attachments[qItem.id] || []"
                    :key="file.id"
                    class="attachment-item"
                  >
                    <el-image
                      :src="file.url"
                      :preview-src-list="[file.url]"
                      fit="cover"
                    ></el-image>
                    <i
                      class="el-icon-delete delete-btn"
                      @click="handleAttachmentDelete(file.id, qItem)"
                    ></i>
                  </div>
                  <el-upload
                    action=""
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="
                      file =>
                        handleAttachmentUpload(
                          file,
                          $route.query.paperId,
                          qItem
                        )
                    "
                    accept="image/*"
                  >
                    <div class="upload-trigger">
                      <i class="el-icon-plus"></i>
                      <span>添加图片</span>
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getExaminationID,
  subAnswer,
  uploadAnswer,
  pushStudentType,
  getTimes,
  uploadFile,
  addUserPaperPhotoRecord,
  delUserPaperPhotoRecord,
  getUserPaperPhotoRecord
} from "@/api/student";
import { convertToFullQuestion } from "@/util/extraction.js";
import _ from "lodash";
import { mapState, mapGetters } from "vuex";

export default {
  name: "ExamPage",
  data() {
    return {
      unfinished: [],
      attachments: {}, // 存储题目附件：{ questionID: [ { id, url, ... } ] }
      isSubmitDisabled: false,
      loading: false,
      str: "\u3000",
      SingXList: [],
      MultXList: [],
      JudgXList: [],
      ProofXList: [],
      FillXList: [],
      AnwsXList: [],
      SingXList1: [],
      MultXList1: [],
      JudgXList1: [],
      ProofXList1: [],
      FillXList1: [],
      AnwsXList1: [],
      subjectType: "singx",
      subjectIndex: 0,
      multIndex: [],
      singIndex: [],
      judgIndex: [],
      orderList: [
        { value: 0, label: "A" },
        { value: 1, label: "B" },
        { value: 2, label: "C" },
        { value: 3, label: "D" },
        { value: 4, label: "E" },
        { value: 5, label: "F" },
        { value: 6, label: "G" },
        { value: 7, label: "H" },
        { value: 8, label: "I" }
      ],
      avataricon: "",
      userInfo: {},
      layout: true,
      submitLoading: false,
      isSubmitting: false,
      pendingUploads: [],
      uploadTimers: {},
      examinationDiff: "",
      examinationSer: "",
      multipleTemp: [],
      startTime: "",
      paperID: "",
      studentNo: {},
      allNumof: 0
    };
  },
  computed: {
    ...mapState({
      examinationInfo: state => state.examination.examinationInfo,
      countdownTime: state => state.examination.countdownTime
    }),
    ...mapGetters(["countdown", "enableSubmit"])
  },
  mounted() {
    this.avataricon = sessionStorage.getItem("avataricon");
    const userInfoStr = localStorage.getItem("userInfo");
    this.userInfo = userInfoStr ? JSON.parse(userInfoStr) : {};
    this.paperID = localStorage.getItem("paperID");
    this.studentNo = this.userInfo;
    this.examinationDiff = this.$route.query.examinationDiff;
    this.examinationSer = this.$route.query.examinationSer;

    document.addEventListener("visibilitychange", this.handleVisibilitychange);
    window.addEventListener("blur", this.handleBlur);
    window.onbeforeunload = function() {
      return "quit?";
    };
    this.getDetail();
  },
  destroyed() {
    localStorage.setItem("numof", this.allNumof);
    clearInterval(this.interval);
    this.clearUploadTimers();
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilitychange
    );
    this.exitFullscreen();
    window.removeEventListener("blur", this.handleBlur);
  },
  methods: {
    exitFullscreen() {
      if (document.exitFullScreen) {
        document.exitFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    },
    screenfullEnter() {
      const el = document.documentElement;
      const fn =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      if (typeof fn !== "undefined" && fn) fn.call(el);
    },
    clearUploadTimers() {
      Object.keys(this.uploadTimers).forEach(key => {
        const timerInfo = this.uploadTimers[key];
        clearTimeout(timerInfo.timer);
        if (timerInfo.resolve) {
          timerInfo.resolve(null);
        }
      });
      this.uploadTimers = {};
    },
    trackUpload(promise) {
      this.pendingUploads.push(promise);
      const removeUpload = () => {
        this.pendingUploads = this.pendingUploads.filter(item => item !== promise);
      };
      promise.then(removeUpload, removeUpload);
      return promise;
    },
    uploadAnswerSafely(payload, options = {}) {
      if (this.isSubmitting || this.submitLoading) {
        return Promise.resolve(null);
      }
      const delay = 0; // Changed from 800ms debounce to submit immediately
      const doUpload = () => {
        const promise = uploadAnswer(payload)
          .then(res => {
            if (
              res.code !== 200 &&
              !this.isSubmitting &&
              !this.submitLoading
            ) {
              this.$message.error(res.message || "答案保存失败，请稍后重试");
            }
            return res;
          })
          .catch(error => {
            if (!this.isSubmitting && !this.submitLoading) {
              this.$message.error(
                error && error.message
                  ? error.message
                  : "答案保存失败，请稍后重试"
              );
            }
            return null;
          });
        return this.trackUpload(promise);
      };
      if (delay === 0) {
        return doUpload();
      }
      if (this.uploadTimers[key]) {
        clearTimeout(this.uploadTimers[key].timer);
        if (this.uploadTimers[key].resolve) {
          this.uploadTimers[key].resolve(null);
        }
      }
      return new Promise(resolve => {
        this.uploadTimers[key] = {
          timer: setTimeout(() => {
            delete this.uploadTimers[key];
            doUpload().then(resolve);
          }, delay),
          resolve
        };
      });
    },
    async waitPendingUploads() {
      this.clearUploadTimers();
      const uploads = this.pendingUploads.slice();
      if (uploads.length > 0) {
        await Promise.all(uploads.map(item => item.catch(() => null)));
      }
    },
    handleVisibilitychange() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      if (document.visibilityState === "hidden") {
        let params = {
          message: "学生切换浏览器窗口，离开考试页面",
          operateName: "离开页面",
          operateType: 2,
          paperID: this.paperID,
          userID: this.studentNo.studentId
        };
        pushStudentType(params).then(() => {});
        this.$alert(
          "检测到你离开了考试页面，该行为已被记录，请立即返回继续考试。",
          "考场警告",
          { confirmButtonText: "我知道了", type: "warning" }
        );
      }
    },
    handleBlur() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      this.screenfullEnter();
      this.allNumof++;
      let params = {
        message: "学生鼠标焦点不在考试页面，考试过程已记录",
        operateName: "离开页面",
        operateType: 2,
        paperID: this.paperID,
        userID: this.studentNo.studentId
      };
      pushStudentType(params).then(() => {});
      localStorage.setItem("numof", this.allNumof);
      this.$message.error("请不要点击考试页面以外的区域，离开记录已增加。");
    },
    changeLayout() {
      this.loading = true;
      setTimeout(() => {
        this.layout = !this.layout;
        this.$forceUpdate();
        this.loading = false;
      }, 300);
    },
    switchItem(type) {
      this.subjectType = type;
      this.subjectIndex = 0;
      if (type === "multx") {
        this.multipleTemp =
          (this.MultXList[0] && this.MultXList[0].answers) || [];
      }
    },
    singxIndexChange(index) {
      this.subjectIndex = index;
      if (!this.SingXList1[index]) return;
      const arr = this.SingXList1[index].options;
      const arrq = this.SingXList1[index].steam;
      this.SingXList1[index].options = [];
      this.SingXList1[index].steam = [];
      this.$nextTick(() => {
        this.SingXList1[index].options = arr;
        this.SingXList1[index].steam = arrq;
      });
    },
    multiIndexChange(index) {
      this.subjectIndex = index;
      if (!this.MultXList1[index]) return;
      const arr = this.MultXList1[index].options;
      const arrq = this.MultXList1[index].steam;
      this.MultXList1[index].options = [];
      this.MultXList1[index].steam = [];
      this.$nextTick(() => {
        this.MultXList1[index].options = arr;
        this.MultXList1[index].steam = arrq;
      });
      this.multipleTemp =
        (this.MultXList[index] && this.MultXList[index].answers) || [];
    },
    judgexChange(index) {
      this.subjectIndex = index;
      if (!this.JudgXList1[index]) return;
      const arr = this.JudgXList1[index].steam;
      this.JudgXList1[index].steam = [];
      this.$nextTick(() => {
        this.JudgXList1[index].steam = arr;
      });
      this.loadQuestionAttachments(
        this.$route.query.paperId,
        this.JudgXList1[index].id
      );
    },
    fillxChange(index) {
      this.subjectIndex = index;
      if (!this.FillXList1[index]) return;
      const arr = this.FillXList1[index].steam;
      this.FillXList1[index].steam = [];
      this.$nextTick(() => {
        this.FillXList1[index].steam = arr;
      });
      this.loadQuestionAttachments(
        this.$route.query.paperId,
        this.FillXList1[index].id
      );
    },
    proofxChange(index) {
      this.subjectIndex = index;
      if (!this.ProofXList1[index]) return;
      const arr = this.ProofXList1[index].steam;
      this.ProofXList1[index].steam = [];
      this.$nextTick(() => {
        this.ProofXList1[index].steam = arr;
      });
      this.loadQuestionAttachments(
        this.$route.query.paperId,
        this.ProofXList1[index].id
      );
    },
    anwsxChange(index) {
      this.subjectIndex = index;
      if (!this.AnwsXList1[index]) return;
      const arr = this.AnwsXList1[index].steam;
      this.AnwsXList1[index].steam = [];
      this.$nextTick(() => {
        this.AnwsXList1[index].steam = arr;
      });
      this.loadQuestionAttachments(
        this.$route.query.paperId,
        this.AnwsXList1[index].id
      );
    },
    async getDetail() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      const params = {
        paperId: this.$route.query.paperId,
        localIp: this.$route.query.localIp
      };
      try {
        let resctm = await getTimes();
        const currentDate = new Date(String(resctm.data.data).replace(/-/g, "/")).getTime();
        let res = await getExaminationID(params);
        if (!res || (res.code !== 200 && res.code !== 0) || !res.data) {
          loading.close();
          this.$message.error((res && res.message) || "获取试卷失败");
          this.$router.replace("/examination");
          return;
        }
        this.startTime = new Date(String(res.data.startTime).replace(/-/g, "/")).getTime();
        const exammt = Number(this.$route.query.examinationMinute) || 0;
        const endtime = new Date(this.startTime + exammt * 60 * 1000);

        if (currentDate < this.startTime) {
          loading.close();
          this.$message.warning("考试未到开始时间，无法作答");
          this.$router.replace("/examination");
          return;
        }
        if (currentDate > endtime.getTime()) {
          loading.close();
          this.$message.warning("考试已经结束");
          this.$router.replace("/examination");
          return;
        }

        this.$store.commit("setExaminationInfo", {
          examinationCoursesName: this.$route.query.examinationCoursesName,
          examinationMinute: this.$route.query.examinationMinute,
          examinationMinutes:
            exammt - (currentDate - this.startTime) / (60 * 1000),
          endtime: endtime.getTime(),
          startTime: this.startTime
        });

        this.interval = setInterval(() => {
          this.$store.commit("countdownTimeMinus");
          this.checkoutSubmit();
        }, 1000);

        let arrs = res.data.list.map(item => convertToFullQuestion(item));

        this.JudgXList1 = arrs.filter(item => item.subjectType === "JudgX");
        this.FillXList1 = arrs.filter(item => item.subjectType === "FillX");
        this.ProofXList1 = arrs.filter(item => item.subjectType === "ProofX");
        this.AnwsXList1 = arrs.filter(item => item.subjectType === "AnwsX");
        this.SingXList1 = arrs.filter(item => item.subjectType === "SingX");
        this.MultXList1 = arrs.filter(item => item.subjectType === "MultX");

        // 鍗曢€?
        this.SingXList = this.SingXList1.map(item => {
          item.answerIndex = item.order.split(",").map((x, i) => ({
            value: x,
            name: "ABCDEFGHIJKLMN".substr(i, 1)
          }));
          const fditem = item.answerIndex.find(
            ai => ai.value == item.usr_choice
          );
          item.usr_choice = fditem ? fditem.name : "";
          item.answers = item.usr_choice;
          return item;
        });
        this.SingXList.forEach(item => {
          this.singIndex.push(item.answers || "");
        });

        // 澶氶€?
        this.MultXList = this.MultXList1.map(item => {
          let item1 = { ...item };
          item1.answerIndex = item1.order.split(",").map((x, i) => ({
            value: x,
            name: "ABCDEFGHIJKLMN".substr(i, 1)
          }));
          let answs = [];
          item.usr_choice.split(",").forEach(usr_ch => {
            const t = item1.answerIndex.find(ai => ai.value == usr_ch);
            if (t) answs.push(t.name);
          });
          item1.answers = answs;
          return item1;
        });

        // 鍒ゆ柇
        this.JudgXList = this.JudgXList1.map(item => {
          let item1 = { ...item };
          item1.usr_choice = item1.usr_choice.toString();
          item1.order = 0;
          item1.answers =
            item1.usr_choice === "1" ? 1 : item1.usr_choice === "0" ? 0 : "";
          return item1;
        });
        this.JudgXList.forEach(item => {
          this.judgIndex.push(item.answers);
        });

        this.ProofXList = this.ProofXList1.filter(
          item => item.subjectType === "ProofX"
        );
        this.FillXList = this.FillXList1.filter(
          item => item.subjectType === "FillX"
        );
        this.AnwsXList = this.AnwsXList1.filter(
          item => item.subjectType === "AnwsX"
        );

        // 榛樿灞曠ず绗竴涓湁棰樼殑棰樺瀷
        if (this.SingXList.length > 0) this.subjectType = "singx";
        else if (this.MultXList.length > 0) this.subjectType = "multx";
        else if (this.JudgXList.length > 0) this.subjectType = "judgex";
        else if (this.FillXList.length > 0) this.subjectType = "fillx";
        else if (this.ProofXList.length > 0) this.subjectType = "proofx";
        else if (this.AnwsXList.length > 0) this.subjectType = "anwsx";

        const map = {
          singx: this.SingXList,
          multx: this.MultXList,
          judgex: this.JudgXList,
          fillx: this.FillXList,
          proofx: this.ProofXList,
          anwsx: this.AnwsXList
        };

        // 初始加载题目附件
        const curSubjectList = map[this.subjectType] || [];
        if (curSubjectList.length > 0) {
          this.loadQuestionAttachments(
            this.$route.query.paperId,
            curSubjectList[this.subjectIndex].id
          );
        }

        // 如果是滚动模式，加载所有相关题目的附件
        if (!this.layout) {
          [...this.FillXList, ...this.ProofXList, ...this.AnwsXList].forEach(
            q => {
              this.loadQuestionAttachments(this.$route.query.paperId, q.id);
            }
          );
        }

        loading.close();
      } catch (err) {
        console.log(err);
        loading.close();
      }
    },
    SingXListFnc(val) {
      this.SingXList[this.subjectIndex].answers = val;
      const tempAnswer = this.SingXList[this.subjectIndex].answerIndex.find(
        item => item.name == val
      );
      const list = {
        answer: tempAnswer.value,
        correctOrder: this.SingXList[this.subjectIndex].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.SingXList[this.subjectIndex].id,
        knowledgeID: this.SingXList[this.subjectIndex].knowledgeID,
        order: this.SingXList[this.subjectIndex].order,
        qid: this.SingXList[this.subjectIndex].qID,
        qtype: this.SingXList[this.subjectIndex].qtype,
        score: this.SingXList[this.subjectIndex].score
      };
      this.uploadAnswerSafely([list]);
    },
    JudgXListFnc(val) {
      this.JudgXList[this.subjectIndex].answers = val;
      const list = {
        answer: val !== "" ? val.toString() : "",
        correctOrder: this.JudgXList[this.subjectIndex].judge,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.JudgXList[this.subjectIndex].id,
        knowledgeID: this.JudgXList[this.subjectIndex].knowledgeID,
        order: this.JudgXList[this.subjectIndex].order,
        qid: this.JudgXList[this.subjectIndex].qID,
        qtype: this.JudgXList[this.subjectIndex].qtype,
        score: this.JudgXList[this.subjectIndex].score
      };
      this.uploadAnswerSafely([list]);
    },
    scrollSingChange(val, qIdx) {
      this.SingXList[qIdx].answers = val;
      const tempAnswer = this.SingXList[qIdx].answerIndex.find(
        item => item.name == val
      );
      const list = {
        answer: tempAnswer.value,
        correctOrder: this.SingXList[qIdx].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.SingXList[qIdx].id,
        knowledgeID: this.SingXList[qIdx].knowledgeID,
        order: this.SingXList[qIdx].order,
        qid: this.SingXList[qIdx].qID,
        qtype: this.SingXList[qIdx].qtype,
        score: this.SingXList[qIdx].score
      };
      this.uploadAnswerSafely([list]);
    },
    scrollJudgChange(val, qIdx) {
      this.JudgXList[qIdx].answers = val;
      const list = {
        answer: val !== "" ? val.toString() : "",
        correctOrder: this.JudgXList[qIdx].judge,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.JudgXList[qIdx].id,
        knowledgeID: this.JudgXList[qIdx].knowledgeID,
        order: this.JudgXList[qIdx].order,
        qid: this.JudgXList[qIdx].qID,
        qtype: this.JudgXList[qIdx].qtype,
        score: this.JudgXList[qIdx].score
      };
      this.uploadAnswerSafely([list]);
    },
    MultXListChange(value, index) {
      this.$set(this.MultXList[index], "answers", value);
      let list = "";
      value.forEach(v => {
        const t = this.MultXList[index].answerIndex.find(
          item => item.name == v
        );
        list += `${t.value},`;
      });
      if (list.length > 0) list = list.substr(0, list.length - 1);
      const str = {
        answer: list,
        correctOrder: this.MultXList[index].correctOrder,
        examinationDiff: this.$route.query.examinationDiff,
        examinationSer: this.$route.query.examinationSer,
        id: this.MultXList[index].id,
        knowledgeID: this.MultXList[index].knowledgeID,
        order: this.MultXList[index].order,
        qid: this.MultXList[index].qID,
        qtype: this.MultXList[index].qtype,
        score: this.MultXList[index].score
      };
      this.uploadAnswerSafely([str]);
    },
    last() {
      if (this.subjectIndex === 0) return;
      this.subjectIndex--;
      if (this.subjectType === "singx")
        this.singxIndexChange(this.subjectIndex);
      else if (this.subjectType === "multx")
        this.multiIndexChange(this.subjectIndex);
      else if (this.subjectType === "judgex")
        this.judgexChange(this.subjectIndex);
      else if (this.subjectType === "fillx")
        this.fillxChange(this.subjectIndex);
      else if (this.subjectType === "proofx")
        this.proofxChange(this.subjectIndex);
      else if (this.subjectType === "anwsx")
        this.anwsxChange(this.subjectIndex);

      const map = {
        singx: this.SingXList,
        multx: this.MultXList,
        judgex: this.JudgXList,
        fillx: this.FillXList,
        proofx: this.ProofXList,
        anwsx: this.AnwsXList
      };
      const cur = map[this.subjectType] || [];
      if (cur[this.subjectIndex]) {
        this.loadQuestionAttachments(
          this.$route.query.paperId,
          cur[this.subjectIndex].id
        );
      }
    },
    next() {
      const map = {
        singx: this.SingXList,
        multx: this.MultXList,
        judgex: this.JudgXList,
        fillx: this.FillXList,
        proofx: this.ProofXList,
        anwsx: this.AnwsXList
      };
      const cur = map[this.subjectType] || [];
      if (this.subjectIndex < cur.length - 1) {
        this.subjectIndex++;
        if (this.subjectType === "singx")
          this.singxIndexChange(this.subjectIndex);
        else if (this.subjectType === "multx")
          this.multiIndexChange(this.subjectIndex);
        else if (this.subjectType === "judgex")
          this.judgexChange(this.subjectIndex);
        else if (this.subjectType === "fillx")
          this.fillxChange(this.subjectIndex);
        else if (this.subjectType === "proofx")
          this.proofxChange(this.subjectIndex);
        else if (this.subjectType === "anwsx")
          this.anwsxChange(this.subjectIndex);
        if (this.subjectIndex === cur.length - 1) {
          this.$message("该题型已到最后一题");
        }
        this.loadQuestionAttachments(
          this.$route.query.paperId,
          cur[this.subjectIndex].id
        );
      }
    },
    // 加载题目附件
    async loadQuestionAttachments(paperID, questionID) {
      if (!paperID || !questionID) return;
      try {
        const res = await getUserPaperPhotoRecord(paperID, questionID);
        if (res.code === 200) {
          this.$set(this.attachments, questionID, res.data || []);
        }
      } catch (err) {
        console.error("加载附件失败:", err);
      }
    },
    // 处理附件上传
    async handleAttachmentUpload(file, paperID, qItem) {
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        background: "rgba(255, 255, 255, 0.7)"
      });
      try {
        const uploadRes = await uploadFile(file.raw);
        if (uploadRes.code === 200) {
          const url = uploadRes.data;
          // 2. 保存附件记录到后端
          const recordRes = await addUserPaperPhotoRecord({
            paperID: paperID,
            questionID: Number(qItem.id || qItem.qid || qItem.qID),
            userID: this.userInfo.studentId || this.userInfo.id, // 确保关联到当前学生
            url: url
          });

          if (recordRes.code === 200) {
            this.$message.success("附件上传并保存成功");
            // 3. 标记为已答题 (同步至后端)
            const answerPayload = {
              answer: "[已上传附件]",
              correctOrder: qItem.correctOrder || qItem.answer || "",
              examinationDiff: this.$route.query.examinationDiff,
              examinationSer: this.$route.query.examinationSer,
              id: qItem.id,
              knowledgeID: qItem.knowledgeID,
              order: qItem.order,
              qid: qItem.qID || qItem.qid,
              qtype: qItem.subjectType || qItem.qtype,
              score: qItem.score
            };
            await this.uploadAnswerSafely([answerPayload], { immediate: true });

            // 4. 重新加载该题目的附件列表
            this.loadQuestionAttachments(paperID, qItem.id);
          } else {
            this.$message.error("记录保存失败: " + recordRes.message);
          }
        } else {
          this.$message.error("上传失败: " + uploadRes.message);
        }
      } catch (error) {
        console.error("附件处理异常:", error);
        this.$message.error("附件处理过程中发生错误");
      } finally {
        loading.close();
      }
    },
    // 删除附件记录
    async handleAttachmentDelete(recordID, qItem) {
      const questionID = qItem.id;
      try {
        const res = await delUserPaperPhotoRecord(recordID);
        if (res.code === 200) {
          this.$message.success("附件已删除");
          // 更新本地数据 (响应式更新)
          if (this.attachments[questionID]) {
            const newList = this.attachments[questionID].filter(
              item => item.id !== recordID
            );
            this.$set(this.attachments, questionID, newList);

            // 如果附件被删光了，且没有文字答案，则同步清除后端的“已答”状态
            if (newList.length === 0) {
              const clearPayload = {
                answer: "",
                correctOrder: qItem.correctOrder || qItem.answer || "",
                examinationDiff: this.$route.query.examinationDiff,
                examinationSer: this.$route.query.examinationSer,
                id: qItem.id,
                knowledgeID: qItem.knowledgeID,
                order: qItem.order,
                qid: qItem.qID,
                qtype: qItem.subjectType || qItem.qtype,
                score: qItem.score
              };
              await this.uploadAnswerSafely([clearPayload], { immediate: true });
            }
          }
        } else {
          this.$message.error("删除失败: " + res.message);
        }
      } catch (error) {
        console.error("删除附件异常:", error);
        this.$message.error("删除附件过程中发生错误");
      }
    },
    async submit() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      let params = _.cloneDeep(
        [].concat(
          this.SingXList,
          this.MultXList,
          this.JudgXList,
          this.FillXList,
          this.ProofXList,
          this.AnwsXList
        )
      ).map(item => ({
        answer: item.answer,
        correctOrder: item.correctOrder,
        examinationDiff: "",
        examinationSer: this.examinationSer,
        id: item.id,
        knowledgeID: item.knowledgeID,
        order: item.order,
        qid: item.qid,
        qtype: item.subjectType,
        score: item.score
      }));

      this.isSubmitting = true;
      this.submitLoading = true;
      this.isSubmitDisabled = true;
      this.loading = true;
      let keepSubmitLocked = false;
      try {
        await this.waitPendingUploads();
        const res = await subAnswer(params);
        if (res.code === 200) {
          keepSubmitLocked = true;
          this.$message.success("交卷成功");
          const param = {
            message: "学生交卷",
            operateName: "交卷",
            operateType: 3,
            paperID: this.paperID,
            userID: this.studentNo.studentId
          };
          pushStudentType(param).then(() => {});
          window.onbeforeunload = null;
          this.loading = false;
          await this.$alert("客观题 " + res.data + " 分", "提示", {
            confirmButtonText: "确认",
            showClose: false,
            closeOnClickModal: false,
            closeOnPressEscape: false
          });
          this.$router.push("/login");
        } else if (res.code === 15002) {
          keepSubmitLocked = true;
          window.onbeforeunload = null;
          this.$message.warning("已交卷，转入登录");
          this.$router.push("/login");
        } else if (res.code === 15001) {
          this.$message.warning("当前考试不存在");
        } else {
          this.loading = false;
          this.$message.warning(res.message || "交卷失败");
        }
      } catch (error) {
        if (!keepSubmitLocked) {
          this.$message.error(
            error && error.message ? error.message : "交卷失败，请检查网络后重试"
          );
        }
      } finally {
        this.loading = false;
        if (!keepSubmitLocked) {
          this.submitLoading = false;
          this.isSubmitDisabled = false;
          this.isSubmitting = false;
        }
      }
    },
    submitFunc() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      this.isSubmitDisabled = true;
      this.SingXList = this.SingXList.map(item => {
        item.answer = item.answers
          ? (item.answerIndex.find(a => a.name === item.answers) || {}).value ||
            ""
          : "";
        return item;
      });
      this.MultXList = this.MultXList.map(item => {
        if (item.answers && item.answers.length > 0) {
          const temp = _.cloneDeep(item.answers);
          for (var i in item.answers) {
            for (var j in item.answerIndex) {
              if (item.answers[i] === item.answerIndex[j].name) {
                temp[i] = item.answerIndex[j].value;
              }
            }
          }
          item.answer = temp.join(",");
        } else {
          item.answer = "";
        }
        return item;
      });
      this.JudgXList = this.JudgXList.map(item => {
        item.answer =
          item.answers !== "" &&
          item.answers !== undefined &&
          item.answers !== null
            ? item.answers.toString()
            : "";
        return item;
      });

      const overSing = this.SingXList.some(val => val.answer === "");
      const overMult = this.MultXList.some(val => val.answer === "");
      const overJudg = this.JudgXList.some(val => val.answer === "");

      if (!overSing && !overMult && !overJudg) {
        this.$confirm(
          "如提交试卷，将无法再次进入该试卷，试卷成绩将提交",
          "提示",
          {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(() => {
            this.submit();
          })
          .catch(() => {
            this.isSubmitDisabled = false;
          });
      } else {
        this.unfinished = [];
        this.SingXList.forEach((item, i) => {
          if (item.answer === "") this.unfinished.push("单选题" + (i + 1));
        });
        this.MultXList.forEach((item, i) => {
          if (item.answer === "") this.unfinished.push("多选题" + (i + 1));
        });
        this.JudgXList.forEach((item, i) => {
          if (item.answer === "") this.unfinished.push("判断题" + (i + 1));
        });
        this.$alert(this.unfinished.join("、"), "未选择答案", {
          confirmButtonText: "确认"
        });
        this.isSubmitDisabled = false;
        this.$message.error("答题未完成，还有题目未答");
        this.submitLoading = false;
      }
    },
    submitFuncV2() {
      if (this.isSubmitting || this.submitLoading) {
        return;
      }
      this.SingXList = this.SingXList.map(item => {
        item.answer = item.answers
          ? (item.answerIndex.find(a => a.name === item.answers) || {}).value ||
            ""
          : "";
        return item;
      });
      this.MultXList = this.MultXList.map(item => {
        if (item.answers && item.answers.length > 0) {
          const temp = _.cloneDeep(item.answers);
          for (var i in item.answers) {
            for (var j in item.answerIndex) {
              if (item.answers[i] === item.answerIndex[j].name)
                temp[i] = item.answerIndex[j].value;
            }
          }
          item.answer = temp.join(",");
        } else {
          item.answer = "";
        }
        return item;
      });
      this.JudgXList = this.JudgXList.map(item => {
        item.answer = item.answers;
        return item;
      });
      this.submit();
    },
    checkoutSubmit() {
      if (
        this.countdownTime < 0 &&
        !this.isSubmitting &&
        !this.submitLoading
      ) {
        this.submitFuncV2();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/* 鏁翠綋瀹瑰櫒 */
.exam-root {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100vh;
  background: #f5f7fa;
  overflow: hidden;
}

/* 椤堕儴鏍?*/
.exam-header {
  height: 64px;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  background: #fff;
  flex-shrink: 0;

  .header-left {
    display: flex;
    align-items: center;
    gap: 32px;
  }
  .header-cell {
    display: flex;
    align-items: center;
    gap: 8px;

    i {
      font-size: 18px;
      color: #64748b;
    }
    .header-label {
      font-size: 14px;
      color: #334155;
      font-weight: 500;
      white-space: nowrap;
    }

    .header-input {
      ::v-deep .el-input__inner {
        background-color: #f8fafc;
        border-color: #e2e8f0;
        color: #1e293b;
        font-weight: 500;
        text-align: center;
        height: 32px;
        line-height: 32px;
        padding: 0 8px;
      }
      &.small-width {
        width: 140px;
      }
      &.tiny-width {
        width: 100px;
      }
    }
  }
  .exam-name-cell {
    margin-right: 12px;
    padding-right: 24px;
    border-right: 2px solid #f1f5f9;
  }
  .exam-name-text {
    font-size: 18px;
    font-weight: 700;
    color: #0f172a;
    max-width: 350px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .header-right {
    display: flex;
    gap: 12px;

    .layout-btn {
      color: #3b82f6;
      border-color: #dbeafe;
      background-color: #eff6ff;
      &:hover {
        background-color: #dbeafe;
      }
    }
    .submit-btn {
      padding: 0 20px;
      background-color: #3b82f6;
      border-color: #3b82f6;
      font-weight: 600;
    }
  }
}

/* 涓讳綋鍖哄煙 */
.exam-body {
  flex: 1;
  display: flex;
  gap: 20px;
  background: #f5f7fa !important;
  padding: 20px !important;
  min-height: 0;

  &.page {
    font-size: 14px;
  }
}

/* 宸︿晶闈㈡澘 */
.left-panel {
  width: 280px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .user-profile {
    padding: 20px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ebeef5;

    .avatar {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      margin-right: 15px;
      object-fit: cover;
    }
    .user-info {
      display: flex;
      flex-direction: column;
      .uname {
        font-size: 16px;
        font-weight: 500;
        color: #303133;
        margin-bottom: 6px;
      }
      .uno {
        font-size: 13px;
        color: #909399;
      }
    }
  }

  .nav-collapse {
    flex: 1;
    overflow-y: auto;
    border-top: none;
    padding: 0 10px;

    ::v-deep .el-collapse-item__header {
      font-size: 15px;
      font-weight: 500;
      color: #303133;
      padding-left: 10px;
    }
    ::v-deep .el-collapse-item__wrap {
      border-bottom: none;
    }

    .nav-grid {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;
      padding: 10px;

      .nav-circle {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background: #f4f4f5;
        color: #606266;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          color: #409eff;
          background: #ecf5ff;
        }
        &.answered {
          background: #f0f9eb;
          color: #67c23a;
        }
        &.active {
          background: #409eff;
          color: #fff;
          box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
        }
      }
    }
  }
}

/* 鍙充晶棰樼洰鍖哄煙 */
.right {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 30px;
  text-align: left;
  min-height: 0;

  .item {
    padding: 0;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .title {
      width: 100%;
      font-size: 24px;
      margin-bottom: 20px;
      line-height: 1.8;
      text-align: left;
      img {
        vertical-align: middle;
      }
    }

    .groupbox,
    .groupcheckbox {
      width: 100%;
      font-size: 20px;
      text-align: left;
    }
  }

  &.scroll-layout-right {
    overflow-y: auto;
    padding: 20px;
    min-height: 0;

    .scroll-content {
      max-width: 960px;
      margin: 0 auto;
      background: #fff;
      border-radius: 12px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
      padding: 40px;
    }

    .question-section {
      margin-bottom: 40px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .section-header {
      font-size: 20px;
      font-weight: 700;
      color: #0f172a;
      padding: 12px 0;
      margin-bottom: 20px;
      border-bottom: 2px solid #e2e8f0;
    }

    .question-item {
      padding: 24px 0;
      border-bottom: 1px dashed #e2e8f0;
      text-align: left;

      &:last-child {
        border-bottom: none;
      }

      .title {
        font-size: 20px;
        line-height: 1.8;
        margin-bottom: 16px;
        img {
          vertical-align: middle;
        }
      }

      .groupbox,
      .groupcheckbox {
        font-size: 18px;
      }
    }
  }
}

/* 涓婁竴棰?涓嬩竴棰?*/
.bottom-nav {
  width: 100%;
  margin-top: 60px;
  margin-bottom: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .last,
  .next {
    margin: 0 60px;
    cursor: pointer;
  }
  .line {
    color: #eee;
    margin: 0 10px;
  }
}

/* 閫夐」閫氱敤 */
.el_radio_group {
  width: 100%;
  font-size: 26px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  overflow-x: auto;

  .el_radio {
    position: relative;
    padding: 15px;
    display: flex;
    align-items: center;
  }
}

/* 鑷畾涔?checkbox 鏂瑰潡 */
::v-deep .groupbox .el-radio .el-radio__input,
::v-deep .groupcheckbox .el-checkbox .el-checkbox__input {
  width: 40px;
  height: 40px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
}
::v-deep .el-radio__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .el-checkbox .el-checkbox__inner {
  border: 0;
  width: 0;
  height: 0;
}
::v-deep .el_radio_group .el-radio__label,
::v-deep .el_radio_group .el-checkbox__label {
  font-size: 20px;
  width: 80%;
}

/* option-row 鑷畾涔夋牱寮?*/
.option-row {
  cursor: pointer;
  transition: background-color 0.2s;
  border-radius: 4px;
  margin-bottom: 8px;

  &:hover {
    background-color: #f5f7fa;
  }
}
.option-wrapper {
  display: flex;
  align-items: center;
  font-size: 20px;
}
.custom-checkbox {
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
  display: inline-block;
  position: relative;
  background-color: #fff;
  transition: all 0.2s;
  flex-shrink: 0;

  &.is-checked {
    background-color: #409eff;
    border-color: #409eff;

    &::after {
      content: "";
      position: absolute;
      left: 6px;
      top: 2px;
      width: 5px;
      height: 10px;
      border: solid #fff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }
  }
}
.practice-label {
  margin-left: 8px;
  margin-right: 12px;
  font-weight: 500;
  font-size: 20px;
}
.option-content {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  line-height: 1.5;
}

/* 鍒ゆ柇棰樺浘鏍?*/
.box {
  font-size: 40px;
}

/* 闅愯棌 radio/checkbox 鍘熺敓鍦嗗湀 */
::v-deep .option-row .el-radio__input,
::v-deep .option-row .el-checkbox__input {
  display: none !important;
}
::v-deep .option-row .el-radio__label,
::v-deep .option-row .el-checkbox__label {
  padding-left: 0;
}

::v-deep .katex {
  font-size: 24px;
}

/* 附件样式 */
.attachment-container {
  margin-top: 20px;
  width: 100%;
  padding: 15px;
  background: #f8fafc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;

  .attachment-header {
    margin-bottom: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #334155;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .attachment-list {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
  }

  .attachment-item {
    position: relative;
    width: 120px;
    height: 120px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #cbd5e1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
    }

    .delete-btn {
      position: absolute;
      top: 5px;
      right: 5px;
      padding: 4px;
      background: rgba(239, 68, 68, 0.9);
      color: #fff;
      border-radius: 50%;
      cursor: pointer;
      display: none;
      font-size: 14px;
    }

    &:hover .delete-btn {
      display: block;
    }
  }

  .upload-trigger {
    width: 120px;
    height: 120px;
    border: 1px dashed #cbd5e1;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: #fff;
    transition: border-color 0.3s;

    &:hover {
      border-color: #3b82f6;
      color: #3b82f6;
    }

    i {
      font-size: 24px;
      margin-bottom: 5px;
    }

    span {
      font-size: 12px;
    }
  }
}
</style>
